import { render, staticRenderFns } from "./veJkyFundType.vue?vue&type=template&id=37b0243a&scoped=true"
import script from "./veJkyFundType.vue?vue&type=script&lang=js"
export * from "./veJkyFundType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0243a",
  null
  
)

export default component.exports